export enum ProductSelectionEnum {
    Alle = 0,
    Snijbloemen = 1,
    Potplanten = 2,
    Diversen = 3
}